import { useEffect, useState } from 'react';
import { api } from '../api';
import { FrontCategory } from '../data/FrontCategory';

export function useFrontCategoryList() {
    const [frontCategoryList, setFrontCategoryList] = useState<FrontCategory[]>([]);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        api.frontCategory()
            .then((resData) => {
                setLoading(false);
                setFrontCategoryList(resData);
            }).catch(() => {
                setLoading(false);
            });
    }, []);

    return {
        frontCategoryList,
        isLoading,
    };
}
